import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';

/**
 * Shown in place of the map workspace when the user is not authenticated.
 * The map (`app-map`) makes paid tile requests, so it must NOT mount for
 * logged-out visitors — this landing page renders instead and only the login
 * dialog reaches the backend.
 */
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
})
export class LandingComponent {
  constructor(private auth: AuthService) {}

  login(): void {
    this.auth.openLoginDialog();
  }

  // Temporarily disabled: self-service tenant signup is closed, and the
  // action behind it is commented out in AuthController. Restore this and its
  // button together with that action - the dialog kept the 'signup' mode, so
  // that is all it takes.
  // createAccount(): void {
  //   this.auth.openLoginDialog(undefined, 'signup');
  // }
}
